import http, { handleApiResponse, checkResponse } from "@/services/http"
import ApiResponse from "@/models/ApiResponse"

import PartnerPayDate from "../models/PartnerPayDate";
import PayCountType from "../models/PayCountType";
import PayMode from "../models/PayMode";
import PayDayType from "../models/PayDayType";
import Ledger from "../models/Ledger";

export default class PartnerPayDateApi {

    static getPartnerPayDate(id: number): Promise<PartnerPayDate> {
        return http.get<ApiResponse<PartnerPayDate>>(`partner-paydate/paydate/${id}`)
            .then(handleApiResponse);
    }
    
    static updatePartnerPayDate(partnerPayDate: PartnerPayDate): Promise<void> {
        return http.post<ApiResponse<void>>(`partner-paydate/paydate/update`, { partnerPayDate: partnerPayDate })
            .then(handleApiResponse);
    }

    static removePartnerPayDate(id: number): Promise<void> {
        return http.delete<ApiResponse<void>>(`partner-paydate/paydate/remove/${id}`)
            .then(handleApiResponse);
    }
    
    //----------

    static getPayModes(): Promise<PayMode[]> {
        return http.get<ApiResponse<PayMode[]>>(`partner-paydate/supplycomponent/paymodes`)
            .then(handleApiResponse);
    }

    static getPayCountTypes(): Promise<PayCountType[]> {
        return http.get<ApiResponse<PayCountType[]>>(`partner-paydate/supplycomponent/paycounttypes`)
            .then(handleApiResponse);
    }

    static getPayDayTypes(): Promise<PayDayType[]> {
        return http.get<ApiResponse<PayDayType[]>>(`partner-paydate/supplycomponent/paydaytypes`)
            .then(handleApiResponse);
    }

    static getLedgers(): Promise<Ledger[]> {
        return http.get<ApiResponse<Ledger[]>>(`partner-paydate/supplycomponent/ledgers`)
            .then(handleApiResponse);
    }
}